import { useNavigate } from "react-router-dom";
import { ExternalLink } from "lucide-react";

/**
 * Reusable channel reference.
 * - Title is always a clickable link.
 * - If the channel has a public @username → opens it in Telegram (t.me/username).
 * - Otherwise (private channel) → navigates to the in-app channel detail page.
 * - Always shows the @username underneath when available.
 */
export function ChannelLink({
    title,
    username,
    chatId,
    messageId = null,
    showUsername = true,
    className = "",
    testId,
}) {
    const navigate = useNavigate();
    const label = title || (username ? `@${username}` : (chatId != null ? String(chatId) : "—"));

    const tgHref = username
        ? (messageId != null ? `https://t.me/${username}/${messageId}` : `https://t.me/${username}`)
        : null;

    const go = (e) => {
        e.stopPropagation();
        if (tgHref) {
            window.open(tgHref, "_blank", "noopener,noreferrer");
        } else if (chatId != null) {
            navigate(`/channels/${chatId}`);
        }
    };

    return (
        <span className={`inline-flex flex-col items-start min-w-0 ${className}`}>
            <button
                type="button"
                onClick={go}
                data-testid={testId}
                title={username ? `فتح @${username} في تلغرام` : "فتح القناة"}
                className="inline-flex items-center gap-1 max-w-full font-medium text-primary hover:underline focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring rounded"
            >
                <span className="truncate">{label}</span>
                {username && <ExternalLink className="h-3 w-3 shrink-0 opacity-60" />}
            </button>
            {showUsername && username && (
                <button
                    type="button"
                    onClick={go}
                    className="text-[11px] text-muted-foreground font-mono hover:text-primary"
                    dir="ltr"
                >
                    @{username}
                </button>
            )}
        </span>
    );
}

export default ChannelLink;
